import { API_ROUTES } from "../../utils/constants";
import { AxiosBase } from "./index";

export default class UserGroupService extends AxiosBase {
  // 1) GET all groups
  getAllGroups = async ({
    page,
    limit,
    searchQuery,
    sortKey,
    sortDirection,
    navigate,
  }) => {
    try {
      const url = `${
        API_ROUTES.BROADCAST.GROUPS
      }?page=${page}&limit=${limit}&searchQuery=${encodeURIComponent(
        searchQuery
      )}&sortKey=${sortKey}&sortDirection=${sortDirection}`;

      const response = await this.requests.get(url);
      return response;
    } catch (err) {
      throw err;
    }
  };

  // 2) GET single group
  getGroupById = async (id, navigate) => {
    try {
      const url = `${API_ROUTES.BROADCAST.GROUP}/${id}`;
      const response = await this.requests.get(url);
      return response;
    } catch (err) {
      throw err;
    }
  };

  // 3) CREATE new group
  createGroup = async (body, navigate) => {
    try {
      const url = API_ROUTES.BROADCAST.GROUP;
      const response = await this.requests.post(url, body);
      return response;
    } catch (err) {
      throw err;
    }
  };

  // 4) UPDATE group
  updateGroup = async ({ id, body, navigate }) => {
    try {
      const url = `${API_ROUTES.BROADCAST.GROUP}/${id}`;
      const response = await this.requests.put(url, body);
      return response;
    } catch (err) {
      throw err;
    }
  };

  // 5) DELETE group
  deleteGroup = async (groupIds, navigate) => {
    try {
      const url = `${API_ROUTES.BROADCAST.GROUP_DELETE}`;
      const response = await this.requests.delete(url, { groupIds });
      return response;
    } catch (err) {
      throw err;
    }
  };
  deleteSingleGroup = async (id, navigate) => {
    try {
      const url = `${API_ROUTES.BROADCAST.GROUP}/${id}`;
      const response = await this.requests.delete(url);
      return response;
    } catch (err) {
      throw err;
    }
  };

  createBulkGroup = async (formData) => {
    try {
      const url = API_ROUTES.BROADCAST.BULK_USER_GROUP;
      const response = await this.requests.post(url, formData);
      return response;
    } catch (err) {
      throw err;
    }
  };
}
